import axios from 'axios';
import {
  SupportContentResponse,
  SupportMedia,
} from '../interfaces/support';

const { REACT_APP_API_URL } = process.env;

const getMediaUrl = (url: string) => {
  if (url.startsWith('http')) return url;
  return `${REACT_APP_API_URL?.replace('/api', '')}${url}`;
};

export const getAdministrationSupportContent = async (
  token?: string | null
): Promise<SupportContentResponse> => {
  const { data } = await axios.get<SupportContentResponse>(
    `${REACT_APP_API_URL}/support/amministrazione`,
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );

  return data;
};

export const downloadSupportMedia = async (media: SupportMedia) => {
  const response = await axios.get(getMediaUrl(media.url), {
    responseType: 'blob',
  });
  const href = URL.createObjectURL(response.data);
  const link = document.createElement('a');

  link.href = href;
  link.setAttribute('download', media.name);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};
